// src/prototype/config/demoClient.ts
// ============================================================
// DEMO CLIENT CONFIGURATION
// Single source of truth for the prototype demo client.
// All UI references to the client name should import from here.
// ============================================================

export const DEMO_CLIENT = {
  id: "200",
  name: "ACME Health System",
} as const;